import React from 'react';

export const BellIcon = props => {
  return (
    <svg viewBox='0 0 30 30' {...props}>
      <path d='M26.065,22.035a2.086,2.086,0,0,1-.561,1.4A1.8,1.8,0,0,1,24.1,24H17.082a3.817,3.817,0,0,1-1.193,2.807A3.934,3.934,0,0,1,13.082,28a3.817,3.817,0,0,1-2.807-1.193A3.934,3.934,0,0,1,9.082,24H2.065a2.086,2.086,0,0,1-1.4-.561,1.8,1.8,0,0,1-.561-1.4,13.251,13.251,0,0,0,1.4-1.4,17.067,17.067,0,0,0,1.333-1.9A15.869,15.869,0,0,0,4.03,16.281a15.6,15.6,0,0,0,.77-3.228,24.723,24.723,0,0,0,.281-4.07A6.524,6.524,0,0,1,6.907,4.561,7.683,7.683,0,0,1,11.749,2.1a2.049,2.049,0,0,1-.14-.632,1.474,1.474,0,1,1,2.947,0,2.049,2.049,0,0,1-.14.632,8.054,8.054,0,0,1,4.842,2.456,6.214,6.214,0,0,1,1.825,4.421,24.724,24.724,0,0,0,.281,4.07,24.4,24.4,0,0,0,.772,3.228,13.281,13.281,0,0,0,1.193,2.456,17.068,17.068,0,0,0,1.333,1.9,13.251,13.251,0,0,0,1.4,1.4ZM13.293,26.6a.257.257,0,0,0-.281-.281,2.342,2.342,0,0,1-1.614-.632,1.975,1.975,0,0,1-.632-1.614.281.281,0,1,0-.561,0,2.881,2.881,0,0,0,.772,1.965,2.59,2.59,0,0,0,1.965.772C13.223,26.807,13.293,26.737,13.293,26.6Z' />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/BellIcon.jsx